// @ts-nocheck
const setItemInLocalStorage = ({
    payload,
    key
}) => {
    localStorage.setItem(key, JSON.stringify(payload));
};

const getItemFromLocalStorage = ({
    key
}) => {
    if (key) {
        const parsedVal = JSON.parse(localStorage.getItem(key));
        return parsedVal;
    } else return null;
}

export { setItemInLocalStorage, getItemFromLocalStorage };